import React, { useRef, useState, useEffect, useContext } from 'react';
import ReactMarkdown from 'react-markdown';
import { ThemeContext } from '../context/ThemeContext';
import '../styles/chat.css';

const ChatContainer = ({ messages }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const scrollRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      const scrollPosition = (scrollHeight - scrollTop - clientHeight) / scrollHeight;
      setShowScrollButton(scrollPosition > 0.2);
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className="message-container" ref={scrollRef}>
      {messages.map((message, index) => (
        <div 
          key={index} 
          className={`message ${message.isUser ? 'user' : 'ai'} ${isDarkMode ? 'dark' : 'light'}`}
        >
          {message.isUser ? (
            message.text
          ) : (
            <ReactMarkdown>{message.text}</ReactMarkdown>
          )}
        </div>
      ))}
      <div className="message-container-bottom"></div>
    </div>
  );
};

export default ChatContainer; 